<template>
    <c-dialog ref="dialog" title="费用报销详情" mode="slide" width="1000" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.document_number" class="m-detail-tag flex-center-cross">
                <label>{{detailData.application_title || detailData.document_number}}</label>
                <c-state dict="applyStatusDic" tag :value="detailData.status"></c-state>
            </div>
        </template>
        
		<doc-base>
			<template #title>{{detailData.create_user_realname}}_费用报销申请</template>

			<template #info>
				<c-field label="单据编号">
                    {{detailData.document_number}}
                </c-field>
			</template>
		</doc-base>

		<doc-content>
			<c-field label="所在公司">{{detailData.company_name || '-'}}</c-field>
			<c-field label="关联工单">
                <c-link v-if="auth('b_aftersale_order_query')" @click="globalDialog('afterSaleOrderDetail', {props: {id: detailData.order_id}})">{{detailData.order_number}}</c-link>
                <span v-else>{{detailData.order_number}}</span>
            </c-field>
			<c-field label="报销类型"><c-state dict="reimbursementTypeDic" :value="detailData.reimbursement_type"></c-state></c-field>
            <c-field label="服务单据" v-if="detailData.reimbursement_type == 1">
				<c-file-list :value="detailData.receipts_image_url"></c-file-list>
			</c-field>
			<c-field label="拉力报告" v-if="detailData.reimbursement_type == 1">
				<c-file-list :value="detailData.report_image_url"></c-file-list>
			</c-field>
            <c-field label="合计金额">
                ￥{{detailData.total_amount}}
            </c-field>
            <c-field label="报销明细" vertical v-if="detailData.reimbursement_type == 1">

                <c-table :data="detailData.items" border :paging="false">
                    <c-table-column
                            label="费用日期"
                            width="170"
                    >
                        <template #default="{data}">
                            {{data.start_date}}～{{data.end_date}}
                        </template>
                    </c-table-column>
                    <c-table-column
                        label="报销项类型"
                    >
                        <template #default="{data}">
						    <c-state dict="expenseItemTypeDic" :value="data.item_type"></c-state>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="报销项"
                        width="180"
                    >
                        <template #default="{data}">
                            <c-state dict="expenseItemCodeDic" :value="data.item_code"></c-state>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="报销人"
                            name="reimburser_name"
                    ></c-table-column>

                    <c-table-column
                        label="报销金额"
                    >
                        <template #default="{data}">
                            <span>￥{{data.item_amount}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="票据凭证"
                    >
                        <template #default="{data}">
                            <c-file-list :value="data.voucher_images" size="mini"></c-file-list>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="费用描述"
                    >
                        <template #default="{data}">
                            {{data.expense_detail}}
                        </template>
                    </c-table-column>
                </c-table>
			</c-field>

            <c-field label="报销明细" vertical v-if="detailData.reimbursement_type == 2">
                <c-table :data="detailData.items" border :paging="false">
                    <c-table-column
                            label="费用日期"
                            width="200"
                    >
                        <template #default="{data}">
                            {{data.start_date}}～{{data.end_date}}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="报销项类型"
                    >
                        <template #default="{data}">
                            <c-state dict="expenseItemTypeDic" :value="data.item_type"></c-state>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="报销项"
                    >
                        <template #default="{data}">
                            <c-state dict="expenseItemCodeDic" :value="data.item_code"></c-state>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="报销金额"
                    >
                        <template #default="{data}">
                            <span>￥{{data.item_amount}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="票据凭证"
                    >
                        <template #default="{data}">
                            <c-file-list :value="data.voucher_images" size="mini"></c-file-list>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="费用描述"
                    >
                        <template #default="{data}">
                            {{data.expense_detail}}
                        </template>
                    </c-table-column>
                </c-table>
            </c-field>
            <c-field label="收款人">
                {{detailData.payee_name||'-'}}
            </c-field>
            <c-field label="银行卡号">
                {{detailData.payee_card_no||'-'}}
            </c-field>
            <c-field label="开卡行及支行">
                {{detailData.payee_bank_name||'-'}}
            </c-field>
			<c-field label="备注">{{detailData.remarks}}</c-field>
		</doc-content>

		<doc-log ref="docLog" :form-id="detailData.form_id"></doc-log>

		<doc-handle
			ref="docHandle"
			:order="id"
			:flow="3"
			:status="detailData.status"
			:applicant="detailData.is_founder == 1"
			:approver="detailData.is_approval == 1"
			@update="onHandleUpdate"
			@edit="editHandle"
			@delete="deleteHandle"
			@restart="restartHandle"
		></doc-handle>
		<expense-reimbursement-edit ref="reimbursementEdit" @resolve="onEditResolve"></expense-reimbursement-edit>
    </c-dialog>
</template>

<script>
import ExpenseReimbursementEdit from "@/pages/finance/expense_reimbursement_edit.vue";

export default {
    name: 'expenseReimbursementDetail',
    components: {ExpenseReimbursementEdit},
    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.update();
            this.$refs.dialog.open();
        },

        onHandleUpdate() {
            this.update();
            this.$bus.$emit('expense_reimbursement_list.update');
        },

        editHandle() {
            this.$refs.reimbursementEdit.open(this.detailData);
        },

        restartHandle() {
            this.$refs.dialog.close();
            this.$nextTick(() => {
                this.$bus.$emit('expense_reimbursement_list.edit', {id: this.detailData.id});
            });
        },

        onEditResolve() {
            this.update();
            this.$bus.$emit('expense_reimbursement_list.update');
        },

        deleteHandle() {
            this.$confirm({
                message: '确认删除费用报销【' + (this.detailData.application_title || this.detailData.document_number || this.detailData.id) + '】？删除后不可恢复',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/expense/reimbursement/delete',
                        data: {id: this.detailData.id},
                        loading: true,
                        success: () => {
                            this.$message({message: '删除成功', type: 'success'});
                            this.$refs.dialog.close();
                            this.$bus.$emit('expense_reimbursement_list.update');
                        }
                    });
                },
                cancel: () => {},
            });
        },

        update() {
            this.request({
                url: '/expense/reimbursement/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.$refs.docHandle.init(data.transaction);
                    // 手动刷新流程日志（同一条单据的 formId 不变时，watch 不会触发）
                    this.$refs.docLog && this.$refs.docLog.update();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
